import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import { isSentryEnabled } from "@/lib/sentry";
import { adminRoutes } from "./AdminRoutes";
import { authRoutes } from "./AuthRoutes";
import NotFound from "@/pages/not-found";

const createRouter = isSentryEnabled()
  ? Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)
  : createBrowserRouter;

export const router = createRouter(
  createRoutesFromElements(
    <>
      {authRoutes}
      {adminRoutes}
      <Route path="*" element={<NotFound />} />
    </>,
  ),
);
